import { render, staticRenderFns } from "./quickView.vue?vue&type=template&id=0482739c&scoped=true"
import script from "./quickView.vue?vue&type=script&lang=js"
export * from "./quickView.vue?vue&type=script&lang=js"
import style0 from "./quickView.vue?vue&type=style&index=0&id=0482739c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0482739c",
  null
  
)

export default component.exports